import { render, staticRenderFns } from "./DeliveriesEdit.vue?vue&type=template&id=ac851d38&scoped=true&"
import script from "./DeliveriesEdit.vue?vue&type=script&lang=js&"
export * from "./DeliveriesEdit.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesEdit.vue?vue&type=style&index=0&id=ac851d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac851d38",
  null
  
)

export default component.exports